import ContractRenderer from "src/components/contract-renderer";
import { NETWORK } from "src/config";
import generateSections from "src/cryptoUtilities/contract-sections";
import getChain from "src/cryptoUtilities/getChain";
import { useMetaMask } from "src/store/metamask";

const OP = [
    ["stakingContractNewStakePrivate", "timeRemaining_new_stakePrivate"],
    ["private_stake", "private_stake_timeRemaining"]
   
];

const StakeSection = () => {
    const [data] = useMetaMask();
    const selectedChain = getChain()[NETWORK];

    const sections = generateSections(data, OP);

    // console.log("Rendering StakeSection with sections:", sections, "and selectedChain:", selectedChain.stakingContract_new_stakeprivate);
    return (
        <ContractRenderer
            sections={sections}
            apy={selectedChain.stakingContract_new_stakeprivate}
        />


        
        // stakingContract_selfMaturing_apy_private. has replaced with new private stake contract
    );
};

export default StakeSection;
